// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-center {
  text-align: center;
}

.bundles {
  display: grid;
  grid-template-columns: repeat(5, 220px);
  justify-content: center;
  gap: 20px 0px;
  margin-top: 20px;
}

@media only screen and (max-width: 1100px) {
  .bundles {
    grid-template-columns: repeat(4, 220px);
  }

  .email-checkbox {
    margin-top: 35px;
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 875px) {
  .bundles {
    grid-template-columns: repeat(3, 220px);
  }
}

@media only screen and (max-width: 655px) {
  .bundles {
    grid-template-columns: repeat(2, 220px);
  }
}

@media only screen and (max-width: 430px) {
  .bundles {
    grid-template-columns: repeat(1, 220px);
  }
}

.card {
  width: 200px;
  height: 200px;
  border: 2px solid rgb(66, 66, 66);
  border-radius: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  margin: 0px 10px 0px 10px;
  cursor: pointer;
  transition: 0.2s;
}

.card:hover {
  background-color: rgb(35, 137, 253);
  color: white;
  transform: translateY(-5px);
}

.card-selected {
  width: 200px;
  height: 200px;
  border: 2px solid rgb(66, 66, 66);
  border-radius: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  margin: 0px 10px 0px 10px;
  background-color: rgb(35, 137, 253);
  color: white;
  transition: 0.2s;
}

.customer-id-input {
  font-size: 18px;
  padding: 10px;
}

.help-text {
  font-size: 18px;
  margin-left: 5px;
  margin-right: 5px;
}

.stripe_submit {
  margin-top: 15px;
  margin-bottom: 20px;
  padding: 10px;
  width: 100%;
  font-size: large;
  font-weight: bold;
  background-color: rgb(35, 137, 253);
  color: white;
  border: 0;
  box-shadow: 0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%);
  border-radius: 5px;
  cursor: pointer;
  transition: 0.2s;
}

.stripe_submit:hover {
  background-color: rgb(33, 121, 221);
  transform: translateY(-3px);
}

.stripe-email-input {
  display: block;
  border: 1px solid #979797;
  font-size: 18px;
  width: 700px;
  padding: 10px 14px;
  margin: 15px 0px 15px 0px;
  border-radius: 5px;
  background: #fafafa;
  color: black;
  letter-spacing: 0.025em;
}

@media only screen and (max-width: 720px) {
  .stripe-email-input {
    width: 600px;
  }
}

@media only screen and (max-width: 600px) {
  .stripe-email-input {
    width: 500px;
  }
}

@media only screen and (max-width: 500px) {
  .stripe-email-input {
    width: 400px;
  }
}

@media only screen and (max-width: 400px) {
  .stripe-email-input {
    width: 300px;
  }
}

@media only screen and (max-width: 300px) {
  .stripe-email-input {
    width: 250px;
  }
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #e4e4e4;
  border-bottom-color: rgb(35, 137, 253);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
  } `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,SAAS;EACT,oEAAoE;EACpE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;EACtC;;EAEA;EACA;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;EACA","sourcesContent":[".align-center {\n  text-align: center;\n}\n\n.bundles {\n  display: grid;\n  grid-template-columns: repeat(5, 220px);\n  justify-content: center;\n  gap: 20px 0px;\n  margin-top: 20px;\n}\n\n@media only screen and (max-width: 1100px) {\n  .bundles {\n    grid-template-columns: repeat(4, 220px);\n  }\n\n  .email-checkbox {\n    margin-top: 35px;\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (max-width: 875px) {\n  .bundles {\n    grid-template-columns: repeat(3, 220px);\n  }\n}\n\n@media only screen and (max-width: 655px) {\n  .bundles {\n    grid-template-columns: repeat(2, 220px);\n  }\n}\n\n@media only screen and (max-width: 430px) {\n  .bundles {\n    grid-template-columns: repeat(1, 220px);\n  }\n}\n\n.card {\n  width: 200px;\n  height: 200px;\n  border: 2px solid rgb(66, 66, 66);\n  border-radius: 10%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 18px;\n  margin: 0px 10px 0px 10px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.card:hover {\n  background-color: rgb(35, 137, 253);\n  color: white;\n  transform: translateY(-5px);\n}\n\n.card-selected {\n  width: 200px;\n  height: 200px;\n  border: 2px solid rgb(66, 66, 66);\n  border-radius: 10%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 18px;\n  margin: 0px 10px 0px 10px;\n  background-color: rgb(35, 137, 253);\n  color: white;\n  transition: 0.2s;\n}\n\n.customer-id-input {\n  font-size: 18px;\n  padding: 10px;\n}\n\n.help-text {\n  font-size: 18px;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.stripe_submit {\n  margin-top: 15px;\n  margin-bottom: 20px;\n  padding: 10px;\n  width: 100%;\n  font-size: large;\n  font-weight: bold;\n  background-color: rgb(35, 137, 253);\n  color: white;\n  border: 0;\n  box-shadow: 0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%);\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.stripe_submit:hover {\n  background-color: rgb(33, 121, 221);\n  transform: translateY(-3px);\n}\n\n.stripe-email-input {\n  display: block;\n  border: 1px solid #979797;\n  font-size: 18px;\n  width: 700px;\n  padding: 10px 14px;\n  margin: 15px 0px 15px 0px;\n  border-radius: 5px;\n  background: #fafafa;\n  color: black;\n  letter-spacing: 0.025em;\n}\n\n@media only screen and (max-width: 720px) {\n  .stripe-email-input {\n    width: 600px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .stripe-email-input {\n    width: 500px;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .stripe-email-input {\n    width: 400px;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .stripe-email-input {\n    width: 300px;\n  }\n}\n\n@media only screen and (max-width: 300px) {\n  .stripe-email-input {\n    width: 250px;\n  }\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #e4e4e4;\n  border-bottom-color: rgb(35, 137, 253);\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
